import { useMemo } from "react";
import { useSession } from "next-auth/react";
import { queryClient } from "@utils";

export const useGlobalTeam = () => {
    const { update, data } = useSession();
    const selectedTeamId = data?.teamId;
    const selectedTeam = data?.stale_team;

    const currency = useMemo(() => {
        return selectedTeam?.currency ?? null;
    }, [selectedTeam]);

    return {
        selectedTeam: selectedTeam ?? null,
        selectedTeamId: selectedTeamId ?? null,
        refetchTeam: () => update({ refetch: true }),

        setSelectedTeamId: ({ newOrgId }: { newOrgId: string }) =>
            update({ newOrgId }).then(() => {
                // Invalidate after cookie has been updated
                queryClient.invalidateQueries();
            }),

        currency,
    };
};
